// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3A8i5","checkbox-input":"checkbox_checkbox-input__2kHK3","checkbox-label":"checkbox_checkbox-label__240fH"};